<template>
  <footer id="footer" class="section bg-dark text-white">
    <div class="container">
      <div class="row">
        <div
          class="col-lg-6 text-center text-lg-start wow fadeInUp"
          style="visibility: visible"
        >
          <p class="mb-2 mb-lg-0">
            Copyright © {{ currentDate() }}
            <a class="fw-600" href="#">Bhavin</a>. All Rights Reserved.
          </p>
        </div>
        <div class="col-lg-6 wow fadeInUp" style="visibility: visible">
          <p class="mb-0 text-center text-lg-end">
            Designed by <a class="fw-600" href="#home">Bhavin Dabhi</a>
          </p>
        </div>
      </div>
    </div>
  </footer>  
</template>

<script>
import CryptoJS from 'crypto-js'

export default {
  name: "footer-bottom",
  data(){
    return{
      password:"",
      msg:"",
    }
  },
  methods: {
    currentDate() {
      const current = new Date();
      const date = `${current.getFullYear()}`;
      return date;
    },
    userpswd() {

      if(localStorage.getItem('bdkey') === null){
      

        let convertdata = "dabhibk";

        if(convertdata == this.password){
          let cryptoconvrt = CryptoJS.AES.encrypt(convertdata,'khushi').toString();
          localStorage.setItem('bdkey', cryptoconvrt);
          this.$router.push('portfolio');
          document.querySelector('.loginclose').click();
        }else{
          this.msg = "Please enter valid password"
        }
      }
    },
  },
};
</script>

<style></style>
